<template>
  <PopupInfo
    title="popup.PopupInfoBlockUser.title"
    label="popup.PopupInfoBlockUser.label"
    btn-text="popup.PopupInfoBlockUser.btnText"
    :action="clickAction"
  />
</template>

<script>
import PopupInfo from "@/components/popup/PopupInfo.vue";
import { ActionTypes, store, GetterTypes, MutationTypes } from "@/store";
import { getPartnerIdFromChatId } from "@/firebase/utils";
import { mapGetters } from "vuex";

export default {
  components: { PopupInfo },
  computed: {
    ...mapGetters({
      authId: GetterTypes.GET_AUTH_ID,
      selectedChatId: GetterTypes.GET_SELECTED_CHAT_ID,
    }),
  },
  methods: {
    async clickAction() {
      const chatId = this.selectedChatId ?? this.$route.params.chat_id;
      const partnerId = getPartnerIdFromChatId(this.authId, chatId);
      await store.dispatch(ActionTypes.BLOCK_USER, { partnerId, chatId });
      store.commit(MutationTypes.HIDE_POPUP);
    },
  },
};
</script>
